module.exports = {
    ns: [
        'web.affiliate',
    ],
    defaultNs: 'web',
}